// src/api/mapViewsApi.js
import { fetchWithAuth } from "./fetchWithAuth";

/**
 * Save a map state snapshot and return the view record (with id).
 * @param {{ context: object, project_id?: string, label?: string }} params
 */
export async function saveMapView({ context, project_id, label } = {}) {
  const res = await fetchWithAuth("/api/v1/map-views", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ context, project_id, label }),
  });
  if (!res.ok) throw new Error(`saveMapView failed: ${res.status}`);
  return res.json();
}

/**
 * Fetch a saved map view by ID.
 * @param {string} id
 */
export async function fetchMapView(id) {
  const res = await fetchWithAuth(`/api/v1/map-views/${id}`);
  if (!res.ok) throw new Error(`fetchMapView failed: ${res.status}`);
  return res.json();
}
